import { extractVueListeners as e, removeClassStyleAttrs as t, returnFirstEl as n, safeConcatStrings as r } from "../../common/utils/index.js";
import { t as i } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import a from "../badge/badge.js";
import { DialtoneLocalization as o } from "../../localization/index.js";
import s from "../button/button.js";
import c from "../emoji-text-wrapper/emoji-text-wrapper.js";
import { createBlock as l, createCommentVNode as u, createElementBlock as d, createElementVNode as f, createTextVNode as p, createVNode as m, mergeProps as h, normalizeClass as g, normalizeStyle as _, openBlock as v, renderSlot as y, resolveComponent as b, toDisplayString as x, toHandlers as S, withCtx as C, withModifiers as w } from "vue";
import { DtIconChevronDown as T, DtIconHeadphones as E } from "@dialpad/dialtone-icons/vue";
//#region recipes/leftbar/contact_centers_row/contact_centers_row.vue
var D = {
	compatConfig: { MODE: 3 },
	name: "DtRecipeContactCentersRow",
	components: {
		DtButton: s,
		DtBadge: a,
		DtEmojiTextWrapper: c,
		DtIconHeadphones: E,
		DtIconChevronDown: T
	},
	inheritAttrs: !1,
	props: {
		ariaLabel: {
			type: String,
			default: ""
		},
		description: {
			type: String,
			required: !0
		},
		selected: {
			type: Boolean,
			default: !1
		},
		showActions: {
			type: Boolean,
			default: !0
		},
		unreadCount: {
			type: String,
			default: null,
			validator(e) {
				return e ? /^\d+\+?$/.test(e) : !0;
			}
		}
	},
	emits: ["click", "click-menu"],
	data() {
		return {
			labelWidth: "auto",
			i18n: new o()
		};
	},
	computed: {
		leftbarContactCentersRowClasses() {
			return [
				"d-recipe-leftbar-row",
				"d-recipe-leftbar-row--contact-centers",
				{
					"d-recipe-leftbar-row__unread-count": this.showUnreadCount,
					"d-recipe-leftbar-row--selected": this.selected
				}
			];
		},
		getAriaLabel() {
			let e = isNaN(this.unreadCount) ? this.unreadCount : Number(this.unreadCount);
			return this.ariaLabel ? this.ariaLabel : r([this.description, this.i18n.$t("DIALTONE_UNREAD_MESSAGE_COUNT_TEXT", { unreadCount: e })]);
		},
		contactRowListeners() {
			return e(this.$attrs);
		},
		showUnreadCount() {
			return !!this.unreadCount;
		},
		menuButtonLabel() {
			return this.i18n.$t("DIALTONE_CONTACT_CENTERS_ROW_MENU_BUTTON_LABEL");
		}
	},
	watch: { $props: {
		deep: !0,
		async handler() {
			await this.$nextTick(), this.adjustLabelWidth();
		}
	} },
	mounted() {
		this.resizeObserver = new ResizeObserver(this.adjustLabelWidth), this.resizeObserver.observe(n(this.$el)), this.adjustLabelWidth();
	},
	beforeUnmount: function() {
		this.resizeObserver.disconnect();
	},
	methods: {
		removeClassStyleAttrs: t,
		adjustLabelWidth() {
			this.labelWidth = (n(this.$el)?.querySelector(".d-recipe-leftbar-row__primary")?.clientWidth || 0) - ((n(this.$el)?.querySelector(".d-recipe-leftbar-row__omega")?.clientWidth || 0) + (n(this.$el)?.querySelector(".d-recipe-leftbar-row__alpha")?.clientWidth || 0) + 12) + "px";
		}
	}
}, O = [
	"data-qa",
	"aria-label",
	"title",
	"href"
], k = { class: "d-recipe-leftbar-row__alpha" }, A = {
	key: 0,
	class: "d-recipe-leftbar-row__omega"
}, j = { class: "d-recipe-leftbar-row__action-container" }, M = { class: "d-recipe-leftbar-row__bottom" };
function N(e, t, n, r, i, a) {
	let o = b("dt-icon-headphones"), s = b("dt-emoji-text-wrapper"), c = b("dt-badge"), T = b("dt-icon-chevron-down"), E = b("dt-button");
	return v(), d("div", {
		class: g([
			"d-recipe-leftbar-row__container",
			{ "d-recipe-leftbar-row__container--off-duty": e.$slots.timer },
			e.$attrs.class
		]),
		style: _(e.$attrs.style)
	}, [f("div", {
		class: g(a.leftbarContactCentersRowClasses),
		"data-qa": "dt-recipe-contact-centers-row"
	}, [f("a", h({
		class: "d-recipe-leftbar-row__primary",
		"data-qa": e.$attrs["data-qa"] ?? "d-recipe-leftbar-row-link",
		"aria-label": a.getAriaLabel,
		title: n.description,
		href: e.$attrs.href ?? "javascript:void(0)"
	}, a.removeClassStyleAttrs(e.$attrs), S(a.contactRowListeners, !0), { onClick: t[0] || (t[0] = (t) => e.$emit("click", t)) }), [f("div", k, [m(o, {
		size: "300",
		"data-qa": "dt-recipe-leftbar-row-icon"
	})]), f("div", {
		class: "d-recipe-leftbar-row__label",
		style: _(`flex-basis: ${i.labelWidth}`)
	}, [m(s, {
		class: "d-recipe-leftbar-row__description",
		"data-qa": "dt-recipe-leftbar-row-description",
		size: "200"
	}, {
		default: C(() => [p(x(n.description), 1)]),
		_: 1
	})], 4)], 16, O), n.showActions ? (v(), d("div", A, [e.$slots.end ? y(e.$slots, "end", { key: 0 }) : y(e.$slots, "right", { key: 1 }), f("div", j, [a.showUnreadCount ? (v(), l(c, {
		key: 0,
		class: "d-recipe-leftbar-row__unread-badge",
		"data-qa": "dt-recipe-leftbar-row-unread-badge",
		kind: "count",
		type: "bulletin"
	}, {
		default: C(() => [p(x(n.unreadCount), 1)]),
		_: 1
	})) : u("", !0), m(E, {
		class: "d-recipe-leftbar-row__action",
		"data-qa": "dt-recipe-leftbar-row-action-button",
		"aria-label": a.menuButtonLabel,
		title: a.menuButtonLabel,
		importance: "clear",
		size: 100,
		circle: "",
		onClick: t[1] || (t[1] = w((t) => e.$emit("click-menu", t), ["stop"]))
	}, {
		icon: C(() => [m(T, { size: "100" })]),
		_: 1
	}, 8, ["aria-label", "title"])])])) : u("", !0)], 2), f("div", M, [y(e.$slots, "timer")])], 6);
}
var P = /* @__PURE__ */ i(D, [["render", N]]);
//#endregion
export { P as default };

//# sourceMappingURL=contact-centers-row.js.map